import styled from 'styled-components';

export const StyledContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 30vh;
`;

export const StyledGridContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.large};
  overflow-x: scroll;

  &.no-click-cell-border {
    .MuiDataGrid-root .MuiDataGrid-cell:focus-within {
      outline: none !important;
    }
  }
`;
